import { Paper, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { WidgetDef } from '../registry';

interface Props {
    def: WidgetDef;
    institutionId: string;
    editable: boolean;
    onRemove?: () => void;
}

export default function WidgetCard({ def, institutionId, editable, onRemove }: Props) {
    const Component = def.component;
    return (
        <Paper variant="outlined" sx={{ p: 2, height: '100%', position: 'relative', '&:hover .rm': { opacity: 1 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ flexGrow: 1 }}>{def.title}</Typography>
                {editable && onRemove && (
                    <IconButton className="rm" size="small" aria-label={`Remove ${def.title}`} onClick={onRemove} sx={{ opacity: 0, transition: 'opacity .1s' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
            <Component institutionId={institutionId} />
        </Paper>
    );
}
